import { ModuleFactory } from "../../../permissions";
import { StripeCustomer } from "./data";

export const StripeCustomerModule = (factory: ModuleFactory) =>
  factory({
    name: "stripe-customers",
    pageUrl: "/stripe-customers",
    model: StripeCustomer,
    moduleId: "25a80cb3-bf18-47fd-963a-639212519920",
  });
